import { OrdersService } from "../../services/OrdersService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const useReservationsApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const ordersService = new OrdersService(appConfig.apiBaseUrl);

    const findAllReservations = async (propertyId) => {
        return executeApiOperation(() => ordersService.findAll(propertyId));
    };

    const findReservationById = async (propertyId, id) => {
        return executeApiOperation(() => ordersService.findById(propertyId, id));
    };

    const createReservation = async (propertyId, reservation) => {
        return executeApiOperation(() => ordersService.create(propertyId, reservation));
    };

    const updateReservation = async (propertyId, reservation) => {
        return executeApiOperation(() => ordersService.update(propertyId, reservation));
    };

    const deleteReservation = async (propertyId, id) => {
        return executeApiOperation(() => ordersService.delete(propertyId, id));
    };

    const updateReservationPayments = async (propertyId, id, payments) => {
        return executeApiOperation(() => ordersService.updatePayments(propertyId, id, payments));
    };

    const abandonPayment = async (propertyId, orderId, paymentIds) => {
        return executeApiOperation(() => ordersService.abandonPayment(propertyId, orderId, paymentIds));
    };

    const checkout = async (propertyId, orderId, paymentMethod, paymentIds) => {
        return executeApiOperation(() =>
            ordersService.checkout(propertyId, orderId, paymentMethod, paymentIds)
        );
    };

    return {
        findAllReservations,
        findReservationById,
        createReservation,
        updateReservation,
        deleteReservation,
        updateReservationPayments,
        abandonPayment,
        checkout,
    };
};
